import React from "react";

export default function LocationLoder() {
  return (
    <div className="col-span-12 space-y-4 min-h-max animate-pulse lg:col-span-4 bg-gradient-to-r from-gray-700 to-slate-500 h-screen"></div>
  );
}
